module.exports = __webpack_public_path__ + "img/aaaa1_sample.0ebc8013.png";